import { $http } from '@/plugins/common/http';

export const getAccountBalance = () => {
    return $http.get('/user/balance');
};

export const getTotalPromoCredit = () => {
    return $http.get('/user/promo-credit/total');
};
